// Dev-only helper to hide Webpack Dev Server client overlay iframe
// Useful when benign runtime warnings (e.g., ResizeObserver) spam the overlay
// and block pointer events during development.
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  const injectHideStyle = () => {
    try {
      // Hide the overlay iframe via CSS to avoid blocking interactions
      if (!document.querySelector('style[data-hide-wds-overlay]')) {
        const style = document.createElement('style')
        style.setAttribute('data-hide-wds-overlay', 'true')
        style.textContent =
          'iframe#webpack-dev-server-client-overlay{display:none!important;pointer-events:none!important;}'
        document.head.appendChild(style)
      }
      // Also directly hide the element if already present
      const overlay = document.getElementById('webpack-dev-server-client-overlay')
      if (overlay) {
        overlay.style.display = 'none'
        overlay.style.pointerEvents = 'none'
      }
    } catch (_) {
      // noop
    }
  }

  // Observe DOM mutations so we hide the overlay whenever it gets re-inserted
  try {
    const observer = new MutationObserver(injectHideStyle)
    observer.observe(document.documentElement, { childList: true, subtree: true })
  } catch (_) {
    // In case MutationObserver is unavailable, fallback to interval
    setInterval(injectHideStyle, 1000)
  }

  // Initial attempt
  injectHideStyle()
}
